var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8966 4.96552V2.37931H21.3103C21.6897 2.37931 22 2.06897 22 1.68966C22 1.31034 21.6897 1 21.3103 1H2.68966C2.31034 1 2 1.31034 2 1.68966C2 2.06897 2.31034 2.37931 2.68966 2.37931H5.10345V4.89655C5.10345 6.24138 5.75862 7.51724 6.86207 8.27586L11.069 11.3448L6.93103 14.3103C5.7931 15.1379 5.10345 16.4828 5.10345 17.8966V20.8276C5.10345 20.8966 5.10345 20.931 5.13793 21H2.68966C2.31034 21 2 21.3103 2 21.6897C2 22.069 2.31034 22.3793 2.68966 22.3793H21.3103C21.6897 22.3793 22 22.069 22 21.6897C22 21.3103 21.6897 21 21.3103 21H18.8621C18.8621 20.931 18.8966 20.8966 18.8966 20.8276V17.9655C18.8966 16.5172 18.1724 15.1379 17 14.3103L12.931 11.3448L17.2069 8.27586C18.2759 7.51724 18.8966 6.24138 18.8966 4.96552ZM17.5172 17.9655V20.8276C17.5172 20.8966 17.5172 20.931 17.5517 21H6.44828C6.44828 20.931 6.48276 20.8966 6.48276 20.8276V17.8966C6.48276 16.931 6.96552 16 7.72414 15.4138L12 12.3793L16.2069 15.4483C17.0345 16 17.5172 16.9655 17.5172 17.9655ZM16.4138 7.17241L12 10.3103L7.65517 7.13793C6.93104 6.62069 6.48276 5.7931 6.48276 4.89655V2.37931H17.5172V4.96552C17.5172 5.82759 17.1034 6.65517 16.4138 7.17241Z",
    fill: "#5981E9",
    stroke: "#5981E9",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnNotice);
export default __webpack_public_path__ + "static/media/on_notice.947ab013ccbd2459345aa70556f7a046.svg";
export { ForwardRef as ReactComponent };